import { Box, Container, Divider } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { useAnimation } from "../contexts/AnimationContext";
import HeroImage from "../components/HeroImage";
import CoupleNameAndDate from "../components/CoupleNameAndDate";
import Countdown from "../components/Countdown";
import RSVPButton from "../components/RSVPButton";
import Introduction from "../components/Introduction";
import Schedule from "../components/Schedule";
import DressCode from "../components/DressCode";

function Home() {
  const dividerRef = useRef(null);
  const dividerInView = useInView(dividerRef, { once: true, margin: "0px" });
  const { animationStarted } = useAnimation();

  return (
    <>
      <Box
        id="home"
        component="section"
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          pt: 8,
          pb: 0,
          px: 2,
        }}
      >
        <HeroImage />
        <Container maxWidth="sm">
          <Box
            sx={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 3,
            }}
          >
            <CoupleNameAndDate />
            <Countdown />
            <RSVPButton mt={-4} />
          </Box>
        </Container>
        <Introduction />
        <Schedule />
        <DressCode />
      </Box>
      <Container maxWidth="md" sx={{ mt: 6 }}>
        <Divider
          component={motion.hr}
          ref={dividerRef}
          initial={{ opacity: 0, scaleX: 0 }}
          animate={
            dividerInView && animationStarted
              ? { opacity: 0.3, scaleX: 1 }
              : { opacity: 0, scaleX: 0 }
          }
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          sx={{
            my: 2,
            mx: { xs: 4, sm: 6, md: 8 },
            borderColor: "#8b7355",
          }}
        />
      </Container>
    </>
  );
}

export default Home;
